import { useEffect } from 'react';
import { Stack } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { breadcrumbAction, tabNavigationAction } from '../../../../_actions';
import Loader from '../../../../components/Loader';
import { getQuestionnaireTemplateDetailNavigationItem } from './utils'
import { questionnaireTemplateDetailsActions } from '../../../../_actions/questionnaireTemplateDetails.actions';
import QuestionnaireTemplateDetail from './QuestionnaireTemplateDetail';
import { apps, userAccountRoleConstants } from '../../../../_constants';
import { history } from '../../../../_helpers';

const QuestionnaireTemplateDetails = () => {
  const { questionnaireTemplateId } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch()
  const app = useSelector((state) => state.app);
  const { all = [], } = useSelector((state) => state.buildings);
  const { questionnaireStore: { questionnaireTemplateDetails: { templateDetails} } } = useSelector(state => state);
  const latestVersionNumber = Math.max(...Object.values(templateDetails).map(v => v.version));
  const currentVersionDetails = templateDetails[latestVersionNumber];
  const isSiteManagerOrConstructionQuality = all.some(a => a.roles?.includes(userAccountRoleConstants.siteManager)) && app === apps.constructionQuality;  
  
  useEffect(() => {
    if (!isSiteManagerOrConstructionQuality) {
      if (app === apps.constructionQuality) {
        history.push("/kwaliteitsborging");
      }
    }
  }, [all, isSiteManagerOrConstructionQuality]);

  useEffect(() => {
    const templateDetailsNavigation = getQuestionnaireTemplateDetailNavigationItem(t)
    dispatch(tabNavigationAction.setNavigationTab(templateDetailsNavigation.tabs))
    dispatch(breadcrumbAction.setBreadcrumbItem(templateDetailsNavigation.breadCrumbs))
  }, [dispatch, t, currentVersionDetails])

  useEffect(() => {
    return () => {
      dispatch(questionnaireTemplateDetailsActions.clearQuestionnaireTemplateDetailsStore())
    }
  }, [])


 useEffect(() => {
  if (questionnaireTemplateId) {
    dispatch(questionnaireTemplateDetailsActions.fetchQuestionnaireTemplateDetails(questionnaireTemplateId))
  }
}, [questionnaireTemplateId]);

    return (
  <Stack height="100%">
    {!templateDetails[latestVersionNumber] ? (
      <Loader />
    ) : (
      <QuestionnaireTemplateDetail />
    )}
  </Stack>
)
}

export default QuestionnaireTemplateDetails